// GDPR History Status - Current state of the GDPR job
export const GdprHistoryStatus = {
    RUNNING: 0,
    SUCCESS: 1,
    FAILED: 2
};

// GDPR History Status Labels for display
export const GdprHistoryStatusLabels = {
    [GdprHistoryStatus.RUNNING]: 'Running',
    [GdprHistoryStatus.SUCCESS]: 'Success',
    [GdprHistoryStatus.FAILED]: 'Failed'
};

// GDPR Trigger Type - How the GDPR job was initiated
export const GdprTriggerType = {
    SCHEDULED: 0,
    MANUAL_BY_CUST_NO: 1,
    MANUAL_BY_EMAIL: 2
};

// GDPR Trigger Type Labels for display
export const GdprTriggerTypeLabels = {
    [GdprTriggerType.SCHEDULED]: 'Scheduled',
    [GdprTriggerType.MANUAL_BY_CUST_NO]: 'Manual by Customer #',
    [GdprTriggerType.MANUAL_BY_EMAIL]: 'Manual by Email'
};


// Retention Action - What action was taken on the data
export const RetentionAction = {
    DELETE: 0,
    ANONYMIZE: 1,
    INACTIVATE: 2
};

// Retention Action Labels for display
export const RetentionActionLabels = {
    [RetentionAction.DELETE]: 'Delete',
    [RetentionAction.ANONYMIZE]: 'Anonymize',
    [RetentionAction.INACTIVATE]: 'Inactivate'
};

// Retention Trigger Event - When the retention policy is triggered
export const RetentionTriggerEvent = {
    MODIFIED: 0,
    INACTIVATED: 1,
    CLOSED: 2
};

// Retention Trigger Event Labels for display
export const RetentionTriggerEventLabels = {
    [RetentionTriggerEvent.MODIFIED]: 'Modified',
    [RetentionTriggerEvent.INACTIVATED]: 'Inactivated',
    [RetentionTriggerEvent.CLOSED]: 'Closed'
};


